import { getSpaBaseName, getSpaUrlRootUrl } from '../../config/mpa-config';

// eslint-disable-next-line import/prefer-default-export
export function getBaseName(spaName: string) {
  return getSpaBaseName(spaName);
}

export function getRootUrl(spaName: string) {
  return getSpaUrlRootUrl(spaName);
}

export const noop = () => {};

export function isBOE() {
  return [
    'haapi-boe.bytedance.net',
    'haapi-boe.byteintl.net',
  ].includes(window.location.host);
}
